import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth";

export default function CompanyLogin() {
  // Read company code from URL path: /bd/login → "BD"
  const companyCode = window.location.pathname.split('/').filter(Boolean)[0]?.toUpperCase() || "IWS";
  const { me, login }   = useAuth();
  const navigate        = useNavigate();

  const [company,  setCompany]  = useState(null);  // {name, logo_url, active}
  const [loading,  setLoading]  = useState(true);
  const [empId,    setEmpId]    = useState("");
  const [password, setPw]       = useState("");
  const [error,    setError]    = useState("");
  const [busy,     setBusy]     = useState(false);

  // Redirect if already logged in
  useEffect(() => {
    if (me) window.location.href = `/${companyCode.toLowerCase()}/portal/checkin`;
  }, [me]);

  // Load company info (name, logo, active status)
  useEffect(() => {
    fetch(`/api/superadmin/company/${companyCode}`)
      .then(r => r.json())
      .then(d => {
        if (d.detail) { setError("Company not found."); }
        else setCompany(d);
      })
      .catch(() => setError("Could not connect to server."))
      .finally(() => setLoading(false));
  }, [companyCode]);

  const submit = async (e) => {
    e.preventDefault();
    if (!company?.active) { setError(company?.message || "Subscription inactive."); return; }
    setBusy(true); setError("");
    try {
      sessionStorage.setItem("company_code", companyCode.toUpperCase());
      await login(companyCode.toUpperCase(), empId.toUpperCase().trim(), password);
      window.location.href = `/${companyCode.toLowerCase()}/portal/checkin`;
    } catch(err) {
      setError(err.message || "Login failed.");
    } finally { setBusy(false); }
  };

  if (loading) return (
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#F8FAFC"}}>
      <div style={{color:"#64748B",fontSize:14}}>Loading…</div>
    </div>
  );

  return (
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",
      background:"linear-gradient(135deg,#F0FDFA 0%,#F8FAFC 100%)"}}>
      <div style={{width:"100%",maxWidth:400,background:"#fff",borderRadius:16,
        padding:"40px 36px",boxShadow:"0 4px 24px rgba(0,0,0,.08)"}}>

        {/* Logo / Company branding */}
        <div style={{textAlign:"center",marginBottom:28}}>
          {company?.logo_url ? (
            <img src={company.logo_url} alt={company?.name}
              style={{height:56,objectFit:"contain",marginBottom:12}}/>
          ) : (
            <div style={{fontSize:13,fontWeight:700,letterSpacing:".18em",
              color:"#94A3B8",marginBottom:4}}>INVINCIBLE · HR</div>
          )}
          <h1 style={{fontSize:22,fontWeight:700,color:"#1E293B",margin:"4px 0"}}>
            {company?.name || companyCode.toUpperCase()}
          </h1>
          <p style={{fontSize:13,color:"#94A3B8",margin:0}}>Employee Portal</p>
        </div>

        {/* Subscription expired banner */}
        {company && !company.active && (
          <div style={{padding:"12px 14px",background:"#FEE2E2",borderRadius:8,
            fontSize:13,color:"#991B1B",marginBottom:16,textAlign:"center"}}>
            {company.message || "Subscription expired. Contact your admin."}
          </div>
        )}

        <form onSubmit={submit}>
          <div style={{marginBottom:14}}>
            <label style={{display:"block",fontSize:13,color:"#64748B",marginBottom:6,fontWeight:500}}>
              Employee ID
            </label>
            <input value={empId} onChange={e=>setEmpId(e.target.value)} required
              placeholder="e.g. IWS001"
              style={{width:"100%",padding:"11px 14px",borderRadius:9,
                border:"1px solid #E2E8F0",fontSize:14,boxSizing:"border-box",
                outline:"none",fontFamily:"inherit"}}
              onFocus={e=>e.target.style.borderColor="#0D9488"}
              onBlur={e=>e.target.style.borderColor="#E2E8F0"}/>
          </div>
          <div style={{marginBottom:20}}>
            <label style={{display:"block",fontSize:13,color:"#64748B",marginBottom:6,fontWeight:500}}>
              Password
            </label>
            <input type="password" value={password} onChange={e=>setPw(e.target.value)} required
              style={{width:"100%",padding:"11px 14px",borderRadius:9,
                border:"1px solid #E2E8F0",fontSize:14,boxSizing:"border-box",
                outline:"none",fontFamily:"inherit"}}
              onFocus={e=>e.target.style.borderColor="#0D9488"}
              onBlur={e=>e.target.style.borderColor="#E2E8F0"}/>
          </div>

          {error && (
            <div style={{padding:"10px 14px",background:"#FEE2E2",borderRadius:8,
              fontSize:13,color:"#991B1B",marginBottom:14}}>
              {error}
            </div>
          )}

          <button type="submit" disabled={busy || (company && !company.active)}
            style={{width:"100%",padding:"12px",borderRadius:9,border:"none",
              background: busy || !company?.active ? "#94A3B8" : "#0D9488",
              color:"#fff",fontSize:15,fontWeight:700,cursor:busy?"not-allowed":"pointer",
              transition:"background .15s"}}>
            {busy ? "Signing in…" : "Sign In →"}
          </button>
        </form>

        <div style={{textAlign:"center",marginTop:20,fontSize:11,color:"#CBD5E1"}}>
          Powered by Invincible Web Solutions LLP
        </div>
      </div>
    </div>
  );
}
